import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const container = document.getElementById("root");

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// scripts/prerender.js writes fully-rendered HTML into #root at build time, so
// in production the markup is already there and we hydrate it. Locally (and on
// any route that was not prerendered) #root is empty and we mount normally.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
